export default __webpack_public_path__ + "static/media/seciton3_icon.2df58803.svg";